import { resolveModuleFromPath } from '@/pwa/appTargets';
import type { AudienceRules } from '@/types/platformContent';

export const ANNOUNCEMENT_ENVIRONMENTS = [
  { value: 'geral', label: 'Sistema Principal' },
  { value: 'crm', label: 'CRM' },
  { value: 'vitrine', label: 'Vitrine' },
  { value: 'corretor', label: 'Portal do Corretor' },
  { value: 'simulador', label: 'Simulador' },
] as const;

export type AnnouncementEnvironment = typeof ANNOUNCEMENT_ENVIRONMENTS[number]['value'];

export function resolveAnnouncementEnvironment(pathname: string): AnnouncementEnvironment {
  const path = pathname.toLowerCase();
  if (path === '/portal-corretor' || path.startsWith('/portal-corretor/')) return 'corretor';
  return resolveModuleFromPath(path);
}

/** Display targeting complements, never replaces, server-side audience eligibility. */
export function isAnnouncementEnvironmentAllowed(
  rules: AudienceRules | null | undefined,
  environment: AnnouncementEnvironment,
): boolean {
  const selection = rules?.environments;
  if (!selection) return true;
  const selected = selection.values.includes(environment);
  return selection.mode === 'allow' ? selected : !selected;
}